import { Toolbar } from "@mzc-pdc/ui";
import PropertyPanel from "@components/property-panel";
import RightSideBar from "@routes/rightsidebar";
import React from "react";

const LayoutForPreview = ({ children }) => {
    // const innerHeight = window.innerHeight;

    return (
        <div style={{ flex: 1, height: "100%" }}>
            <section className={"container"}>
                <div
                    className="contents"
                    style={{
                        height: "100%",
                        overflowY: "auto",
                        // DAM-646: 스크롤바 생길 때 콘텐츠 밀림 방지
                        scrollbarGutter: "stable",
                    }}
                >
                    {children}
                </div>
            </section>
        </div>
    );
};

export default LayoutForPreview;
